import { createGlobalStyle } from 'styled-components';

const FontAwesomeStyles = createGlobalStyle`
  /* Font Awesome styles */
  .fas {
    font-family: 'Font Awesome 5 Free';
    font-weight: 900;
  }
  
  .fa-chart-line:before {
    content: "\\f201";
  }
  
  .fa-file-alt:before {
    content: "\\f15c";
  }
  
  .fa-question-circle:before {
    content: "\\f059";
  }
  
  .fa-folder:before {
    content: "\\f07b";
  }
  
  .fa-arrow-up:before {
    content: "\\f062";
  }
  
  .fa-clipboard-list:before {
    content: "\\f46d";
  }
  
  .fa-calendar-check:before {
    content: "\\f274";
  }
  
  .fa-sitemap:before {
    content: "\\f0e8";
  }
  
  .fa-users:before {
    content: "\\f0c0";
  }
`;

export default FontAwesomeStyles; 